import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    display: 'flex'
  }
}));

export default useStyles;
